import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { Reveal, Label } from "@/components/motion";
import { CONTACT, IMAGES, img, useTitle } from "@/data/site";

export default function Careers() {
  useTitle("Careers | Urban Trail");

  return (
    <div data-testid="careers-page">
      <PageHero
        image={IMAGES.careersHero}
        label="Careers"
        titleLines={["Build a career", "around the world."]}
        sub="We are building a travel company driven by curiosity, creativity, thoughtful service and a passion for discovering the world."
        tall
      />

      <section className="bg-white">
        <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
          <div className="grid items-center gap-16 lg:grid-cols-12">
            <Reveal className="lg:col-span-7">
              <div className="group overflow-hidden">
                <img
                  src={IMAGES.careersLife}
                  alt="Travellers on a Himalayan road"
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.03]"
                />
              </div>
            </Reveal>
            <div className="lg:col-span-4 lg:col-start-9">
              <Reveal>
                <Label>Life at Urban Trail</Label>
              </Reveal>
              <Reveal delay={0.08}>
                <h2 className="mt-6 font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink sm:text-5xl">
                  Work that begins with wanderlust.
                </h2>
              </Reveal>
              <Reveal delay={0.16}>
                <p className="mt-8 text-base leading-relaxed text-graphite">
                  We are a small team with a large map. At Urban Trail, you'll help
                  shape journeys people remember for the rest of their lives — with
                  the freedom to explore, the support to do your best work, and
                  colleagues who care about the details.
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-mist bg-white">
        <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-36">
          <Reveal>
            <Label>Open Positions</Label>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink sm:text-5xl">
              Join the journey.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <div
              data-testid="careers-no-openings"
              className="mt-16 border border-dashed border-mist p-12 text-center lg:p-20"
            >
              <p className="font-serif text-3xl font-light text-ink">
                No open positions right now.
              </p>
              <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-steel">
                We're always interested in meeting talented people who love travel and
                believe in creating better experiences. Introduce yourself — we'd love
                to hear from you.
              </p>
              <a
                href={`mailto:${CONTACT.email}?subject=Career%20at%20Urban%20Trail`}
                data-testid="careers-send-profile"
                className="btn-outline-dark mt-10"
              >
                Send Your Profile
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand
        image={img.uns("photo-1645966246920-071dbd7b24e3", 2200)}
        title="The road is open."
        sub="Tell us where you'd like to go next — as a traveller or as a colleague."
        primaryText="Plan Your Journey"
        primaryTo="/contact"
      />
    </div>
  );
}
